export default "__VITE_ASSET__LDv77s5j__"